import TrophyCabinet from './TrophyCabinet';
export default TrophyCabinet;
